module.exports = __webpack_public_path__ + "img/icon1.4a5cb6b7.png";